module.exports = __webpack_public_path__ + "static/media/portada.dd04c765.webp";